/* Ward rounds and nursing (docs/plans/phase2-ward-rounds-nursing.md §5): the worklist, the
 * ward round, the vitals chart and notes. Tokens only; `danger` only for clinical danger
 * (a critical value). */

.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.columns {
  display: grid;
  grid-template-columns: minmax(0, 3fr) minmax(0, 2fr);
  gap: var(--space-5);
  align-items: start;
}

.column {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  min-width: 0;
}

@media (width < 1100px) {
  .columns {
    grid-template-columns: minmax(0, 1fr);
  }
}

.meta {
  margin: 0;
  color: var(--graphite);
  font: var(--t-small);
}

.numeric {
  font-variant-numeric: tabular-nums;
}

.round {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding-bottom: var(--space-5);
  border-bottom: 1px solid var(--rule);
}

.round:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}

.roundHeading {
  margin: 0;
  font: var(--t-body-strong);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.vitalsGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(11rem, 1fr));
  gap: var(--space-3) var(--space-4);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

.list {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
}

.item {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  padding: var(--space-3) 0;
  border-bottom: 1px solid var(--rule);
}

.item:last-child {
  border-bottom: 0;
}

.item[data-status='entered_in_error'] .text {
  color: var(--graphite);
  text-decoration: line-through;
}

.itemHead {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
}

.text {
  max-width: 75ch;
  margin: 0;
  white-space: pre-wrap;
  line-height: 1.55;
}

.chartBlock {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.chart {
  margin: 0;
}

.chartSvg {
  display: block;
  width: 100%;
  max-height: 16rem;
}

.axis {
  stroke: var(--border-strong);
  stroke-width: 1;
}

.axisLabel {
  fill: var(--graphite);
  font: var(--t-micro);
  font-variant-numeric: tabular-nums;
}

.line {
  fill: none;
  stroke: var(--ink);
  stroke-width: 2;
  stroke-linejoin: round;
}

.point {
  fill: var(--paper);
  stroke: var(--ink);
  stroke-width: 2;
}

.point[data-shape='flagged'] {
  fill: var(--ink);
}

.point[data-shape='critical'] {
  fill: var(--danger);
  stroke: var(--danger);
}

.caption {
  margin-top: var(--space-2);
  color: var(--graphite);
  font: var(--t-small);
}

.critical {
  color: var(--danger);
  font: var(--t-body-strong);
}
